import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";
import type { Mode } from "@/types/api.types";

interface ModeViewProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  mode: Mode | null;
}

export default function ModeView({ open, onOpenChange, mode }: ModeViewProps) {
  if (!mode) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl bg-white">
        <DialogHeader>
          <DialogTitle>Mode Details</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          {/* Logo */}
          {mode.logo && (
            <div className="flex justify-center">
              <img
                src={mode.logo}
                alt={mode.name}
                className="w-24 h-24 rounded-lg object-cover"
              />
            </div>
          )}

          {/* Name & Status */}
          <div>
            <div className="flex items-center gap-2 mb-2">
              <h3 className="text-2xl font-bold">{mode.name}</h3>
              <Badge
                variant={mode.isActive ? "success" : "secondary"}
                className={
                  mode.isActive
                    ? "bg-green-100 text-green-800"
                    : "bg-gray-100 text-gray-800"
                }
              >
                {mode.isActive ? "Active" : "Inactive"}
              </Badge>
            </div>
            {mode.description && (
              <p className="text-gray-600">{mode.description}</p>
            )}
          </div>

          {/* Details */}
          <div className="grid grid-cols-2 gap-4 border-t pt-4">
            <div>
              <p className="text-sm font-medium text-gray-500">Slug</p>
              <code className="text-sm bg-gray-100 px-2 py-1 rounded">
                {mode.slug}
              </code>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500">Order</p>
              <p className="text-sm">{mode.order}</p>
            </div>
            <div className="col-span-2">
              <p className="text-sm font-medium text-gray-500">Route</p>
              <code className="text-sm text-blue-600">{mode.route}</code>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500">Created</p>
              <p className="text-sm">
                {new Date(mode.createdAt).toLocaleDateString()}
              </p>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500">Updated</p>
              <p className="text-sm">
                {new Date(mode.updatedAt).toLocaleDateString()}
              </p>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
